/**
 * Voyage Quick Entry Panel Component
 */

import React from 'react';

const VoyageQuickEntryPanel = ({ activeVoyage, onAddLogEntry }) => {
  if (!activeVoyage) return null;

  return (
    <div className="bg-white shadow rounded-lg mb-6">
      <div className="px-5 py-3 border-b border-gray-200">
        <h3 className="text-base font-medium text-gray-900">Voyage Quick Entries</h3>
        <p className="text-xs text-gray-500 mt-0.5">
          Quick log entries for {activeVoyage.voyageNumber || 'current voyage'}
        </p>
      </div>
      <div className="p-4">
        <div className="grid grid-cols-3 gap-2">
          <button
            onClick={() => onAddLogEntry({
              type: 'position',
              summary: 'Position update',
              voyageId: activeVoyage.id
            })}
            className="p-2 text-xs text-center border border-gray-200 rounded-lg hover:bg-gray-50"
          >
            📍 Position
          </button>
          <button
            onClick={() => onAddLogEntry({
              type: 'weather',
              summary: 'Weather observation',
              voyageId: activeVoyage.id
            })}
            className="p-2 text-xs text-center border border-gray-200 rounded-lg hover:bg-gray-50"
          >
            ☁️ Weather
          </button>
          <button
            onClick={() => onAddLogEntry({
              type: 'navigation',
              summary: 'Navigation event',
              voyageId: activeVoyage.id
            })}
            className="p-2 text-xs text-center border border-gray-200 rounded-lg hover:bg-gray-50"
          >
            🧭 Nav Event
          </button>
          <button
            onClick={() => onAddLogEntry({
              type: 'nav_warning',
              summary: 'Navigation warning',
              voyageId: activeVoyage.id
            })}
            className="p-2 text-xs text-center border border-gray-200 rounded-lg hover:bg-gray-50"
          >
            ⚠️ Nav Warning
          </button>
          <button
            onClick={() => onAddLogEntry({
              type: 'pilot',
              summary: 'Pilot transfer',
              voyageId: activeVoyage.id
            })}
            className="p-2 text-xs text-center border border-gray-200 rounded-lg hover:bg-gray-50"
          >
            👥 Pilot
          </button>
          <button
            onClick={() => onAddLogEntry({
              type: 'anchor',
              summary: 'Anchor operation',
              voyageId: activeVoyage.id
            })}
            className="p-2 text-xs text-center border border-gray-200 rounded-lg hover:bg-gray-50"
          >
            ⚓ Anchor
          </button>
        </div>
      </div>
    </div>
  );
};

export default VoyageQuickEntryPanel;